import { PromotionTypesStateType, RootState } from '@types'
import { createSelector } from 'reselect'

const stateSelector = (state: RootState): PromotionTypesStateType =>
  state.PromotionTypes

export const selectPromotionTypes = createSelector(stateSelector, (s) => s.all)
